// extracted by mini-css-extract-plugin
export default {"forceActivationSection":"force_forceActivationSection__u7Snu","buttonContainer":"force_buttonContainer__KGt0j"};